import { render, staticRenderFns } from "./GroupRoomList.vue?vue&type=template&id=df231996"
import script from "./GroupRoomList.vue?vue&type=script&lang=js"
export * from "./GroupRoomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports